import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider } from './chunk-J2FXRRBJ.js';
import { __spreadValues, __spreadProps } from './chunk-2FEJBM4N.js';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, ButtonGroup, Icon, Popover, Typography, RadioGroup, Stack, Radio, Grid, CircularProgress, TextField, InputAdornment, FormControlLabel, Checkbox, MenuItem, Tooltip } from '@mui/material';
import { get } from 'lodash';
import React10, { useEffect } from 'react';
import { FixedSizeList } from 'react-window';
import SearchIcon from '@mui/icons-material/Search';
import gsap from 'gsap';

var ApplyCancel = (props) => {
  const {
    handleCancelClick,
    handleApplyClick,
    changedLabel,
    isChanged,
    enableApplyAlways,
    rootSx
  } = props;
  return /* @__PURE__ */ React10.createElement(
    Box,
    {
      sx: __spreadValues({
        bgcolor: "white",
        zIndex: 5,
        px: 2,
        py: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "10px",
        position: "sticky",
        bottom: 0
      }, rootSx)
    },
    /* @__PURE__ */ React10.createElement(
      Button,
      {
        size: "small",
        variant: "text",
        onClick: () => {
          handleCancelClick();
        },
        sx: {
          px: "20px",
          py: "15px"
        }
      },
      "Cancel"
    ),
    /* @__PURE__ */ React10.createElement(
      Button,
      {
        size: "small",
        variant: "contained",
        disabled: !isChanged && !enableApplyAlways,
        onClick: () => {
          handleApplyClick();
        },
        "data-testid": "applyBtn",
        sx: {
          px: "20px",
          py: "15px"
        }
      },
      "Apply (",
      changedLabel,
      ")"
    )
  );
};
var ApplyCancel_default = ApplyCancel;
function Option(props) {
  const {
    option,
    handleSelect,
    label,
    multiple,
    isSelected,
    disableOnlyBtn,
    handleOnlyClick,
    renderOption,
    style,
    sx
  } = props;
  return /* @__PURE__ */ React10.createElement(
    MenuItem,
    {
      onClick: (e) => {
        handleSelect(option.value, !isSelected, e);
      },
      sx: __spreadValues(__spreadProps(__spreadValues({}, style), {
        paddingTop: 0,
        paddingBottom: 0,
        width: "350px",
        "&:hover .selectOnlyBtn": {
          display: "inline-block"
        }
      }), sx),
      "data-testid": "optionItem"
    },
    renderOption ? renderOption(option, {
      isSelected: multiple ? isSelected : void 0,
      handleOnlyClick
    }) : /* @__PURE__ */ React10.createElement(Tooltip, { title: option.label }, /* @__PURE__ */ React10.createElement(
      Box,
      {
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "5px"
        }
      },
      multiple && /* @__PURE__ */ React10.createElement(
        Checkbox,
        {
          checked: isSelected,
          sx: {
            "& .MuiSvgIcon-root": { fontSize: 16 },
            color: "rgba(230, 230, 230, 0.90)"
          }
        }
      ),
      /* @__PURE__ */ React10.createElement(
        Typography,
        {
          fontWeight: 400,
          color: "#000",
          sx: { fontSize: "12px", flex: 1, display: "inline-block" },
          noWrap: true
        },
        option.label === "" ? `No ${label ? label : "value"}` : option.label
      ),
      multiple && !disableOnlyBtn && /* @__PURE__ */ React10.createElement(
        Button,
        {
          variant: "text",
          className: "selectOnlyBtn",
          onClick: (e) => {
            e.stopPropagation();
            handleOnlyClick(option.value);
          },
          sx: {
            display: "none",
            color: "#130F26",
            backgroundColor: "#ECECEC",
            fontSize: "12px",
            padding: "4px 8px"
          },
          "data-testid": "onlyBtn"
        },
        "Only"
      ),
      option.count && /* @__PURE__ */ React10.createElement(
        Typography,
        {
          fontWeight: 400,
          color: "#000",
          align: "right",
          sx: { fontSize: "12px", width: "30px", direction: "rtl" },
          noWrap: true
        },
        option.count
      )
    ))
  );
}
var Option_default = Option;

// src/components/FilterSelect/components/OptionsList.tsx
function OptionsList(props) {
  const {
    options,
    optionItemProps,
    selectedValue,
    multiple,
    isChanged,
    addUndefinedOption,
    renderOption,
    width,
    height
  } = props;
  const { handleSelect, label, disableOnlyBtn, handleOnlyClick, menuItemSx } = optionItemProps;
  const finalWidth = React10.useMemo(() => {
    if (width) return width;
    return 350;
  }, [width]);
  return /* @__PURE__ */ React10.createElement(React10.Fragment, null, addUndefinedOption && /* @__PURE__ */ React10.createElement(
    Option_default,
    {
      option: {
        label: `Select${label && ` ${label}`}`,
        value: void 0
      },
      handleSelect,
      label: label ? label : null,
      disableOnlyBtn: true,
      renderOption,
      sx: __spreadValues({
        height: 42,
        width: finalWidth
      }, menuItemSx)
    }
  ), /* @__PURE__ */ React10.createElement(
    FixedSizeList,
    {
      height: height ? height : options.length * 42 > window.innerHeight - 150 ? isChanged ? window.innerHeight - 197 : window.innerHeight - 150 : options.length * 42,
      itemSize: 42,
      itemCount: options.length,
      itemData: options,
      width: finalWidth,
      style: {
        overflowX: "hidden"
      }
    },
    ({ index: position, style }) => {
      const option = options[position];
      return /* @__PURE__ */ React10.createElement(
        Option_default,
        {
          option,
          handleSelect,
          label: label ? label : null,
          multiple,
          isSelected: multiple && Array.isArray(selectedValue) && selectedValue.includes(option.value),
          disableOnlyBtn,
          handleOnlyClick: multiple && handleOnlyClick,
          style,
          renderOption,
          sx: __spreadValues({
            width: finalWidth
          }, menuItemSx)
        }
      );
    }
  ));
}
var OptionsList_default = OptionsList;
var SearchBar = (props) => {
  const { searchText, setSearchText, label, multiple, sx } = props;
  return /* @__PURE__ */ React10.createElement(
    TextField,
    {
      size: "small",
      value: searchText,
      onChange: (e) => {
        e.stopPropagation();
        setSearchText(e.target.value);
      },
      onKeyDown: (e) => {
        e.stopPropagation();
      },
      placeholder: `Search${label ? ` for ${label}` : ""}`,
      variant: "standard",
      sx: __spreadValues({
        fontSize: "12px",
        marginBottom: "8px",
        marginTop: multiple ? "4px" : "0px",
        "& .MuiInputBase-input": { padding: "11px 11px 11px 0px" },
        "& .MuiInputBase-root": {
          fontSize: "12px",
          paddingLeft: "13px",
          backgroundColor: "rgba(217, 217, 217, 0.2)"
        },
        "& ::placeholder": { color: "#000", opacity: 1 }
      }, sx),
      InputProps: {
        startAdornment: /* @__PURE__ */ React10.createElement(InputAdornment, { position: "start" }, /* @__PURE__ */ React10.createElement(SearchIcon, { sx: { fontSize: 14, color: "#1C1B1F" } })),
        disableUnderline: true
      },
      "data-testid": "searchInput"
    }
  );
};
var SearchBar_default = SearchBar;
var SelectAll = (props) => {
  const {
    isSelectAll,
    handleSelectAllChange,
    selectAllLabel,
    handleClearSelections
  } = props;
  return /* @__PURE__ */ React10.createElement(
    Box,
    {
      sx: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px"
      }
    },
    /* @__PURE__ */ React10.createElement(
      FormControlLabel,
      {
        control: /* @__PURE__ */ React10.createElement(
          Checkbox,
          {
            checked: isSelectAll,
            onChange: handleSelectAllChange,
            sx: {
              mx: "6px",
              "& .MuiSvgIcon-root": { fontSize: 16 },
              color: "rgba(230, 230, 230, 0.90)"
            },
            "data-testid": "selectAllCheckbox"
          }
        ),
        label: /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000" }, selectAllLabel),
        sx: { display: "flex" },
        onClick: (e) => e.stopPropagation()
      }
    ),
    handleClearSelections && /* @__PURE__ */ React10.createElement(
      Button,
      {
        variant: "text",
        onClick: handleClearSelections,
        sx: {
          color: "#130F26",
          backgroundColor: "#ECECEC",
          fontSize: "12px",
          padding: "4px 8px"
        }
      },
      "Clear"
    )
  );
};
var SelectAll_default = SelectAll;

// src/utils/functions/pluralize.ts
var pluralRules = [];
var singularRules = [];
var uncountables = {};
var irregularPlurals = {};
var irregularSingles = {};
function sanitizeRule(rule) {
  if (typeof rule === "string") {
    return new RegExp("^" + rule + "$", "i");
  }
  return rule;
}
function restoreCase(word, token) {
  if (word === token) return token;
  if (word === word.toLowerCase()) return token.toLowerCase();
  if (word === word.toUpperCase()) return token.toUpperCase();
  if (word[0] === word[0].toUpperCase()) {
    return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
  }
  return token.toLowerCase();
}
function interpolate(str, args) {
  return str.replace(/\$(\d{1,2})/g, function(match, index) {
    return args[index] || "";
  });
}
function replace(word, rule) {
  return word.replace(rule[0], function(match, index) {
    let result = interpolate(rule[1], [match, index]);
    if (match === "") {
      return restoreCase(word[index - 1], result);
    }
    return restoreCase(match, result);
  });
}
function sanitizeWord(token, word, rules) {
  if (!token.length || uncountables.hasOwnProperty(token)) {
    return word;
  }
  let len = rules.length;
  while (len--) {
    let rule = rules[len];
    if (rule[0].test(word)) return replace(word, rule);
  }
  return word;
}
function replaceWord(replaceMap, keepMap, rules) {
  return function(word) {
    let token = word.toLowerCase();
    if (keepMap.hasOwnProperty(token)) {
      return restoreCase(word, token);
    }
    if (replaceMap.hasOwnProperty(token)) {
      return restoreCase(word, replaceMap[token]);
    }
    return sanitizeWord(token, word, rules);
  };
}
function checkWord(replaceMap, keepMap, rules) {
  return function(word) {
    let token = word.toLowerCase();
    if (keepMap.hasOwnProperty(token)) return true;
    if (replaceMap.hasOwnProperty(token)) return false;
    return sanitizeWord(token, token, rules) === token;
  };
}
function pluralize(word, count, inclusive) {
  let pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
  return (inclusive ? count + " " : "") + pluralized;
}
pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
pluralize.singular = replaceWord(
  irregularPlurals,
  irregularSingles,
  singularRules
);
pluralize.isSingular = checkWord(
  irregularPlurals,
  irregularSingles,
  singularRules
);
pluralize.addPluralRule = function(rule, replacement) {
  pluralRules.push([sanitizeRule(rule), replacement]);
};
pluralize.addSingularRule = function(rule, replacement) {
  singularRules.push([sanitizeRule(rule), replacement]);
};
pluralize.addUncountableRule = function(word) {
  if (typeof word === "string") {
    uncountables[word.toLowerCase()] = true;
    return;
  }
  pluralize.addPluralRule(word, "$0");
  pluralize.addSingularRule(word, "$0");
};
pluralize.addIrregularRule = function(single, plural) {
  plural = plural.toLowerCase();
  single = single.toLowerCase();
  irregularSingles[single] = plural;
  irregularPlurals[plural] = single;
};
[
  // Pronouns.
  ["I", "we"],
  ["me", "us"],
  ["he", "they"],
  ["she", "they"],
  ["them", "them"],
  ["myself", "ourselves"],
  ["yourself", "yourselves"],
  ["itself", "themselves"],
  ["herself", "themselves"],
  ["himself", "themselves"],
  ["themself", "themselves"],
  ["is", "are"],
  ["was", "were"],
  ["has", "have"],
  ["this", "these"],
  ["that", "those"],
  ["my", "our"],
  ["its", "their"],
  ["his", "their"],
  ["her", "their"],
  // Words ending in with a consonant and `o`.
  ["echo", "echoes"],
  ["dingo", "dingoes"],
  ["volcano", "volcanoes"],
  ["tornado", "tornadoes"],
  ["torpedo", "torpedoes"],
  // Ends with `us`.
  ["genus", "genera"],
  ["viscus", "viscera"],
  // Ends with `ma`.
  ["stigma", "stigmata"],
  ["stoma", "stomata"],
  ["dogma", "dogmata"],
  ["lemma", "lemmata"],
  ["schema", "schemata"],
  ["anathema", "anathemata"],
  // Other irregular rules.
  ["ox", "oxen"],
  ["axe", "axes"],
  ["die", "dice"],
  ["yes", "yeses"],
  ["foot", "feet"],
  ["eave", "eaves"],
  ["goose", "geese"],
  ["tooth", "teeth"],
  ["quiz", "quizzes"],
  ["human", "humans"],
  ["proof", "proofs"],
  ["carve", "carves"],
  ["valve", "valves"],
  ["looey", "looies"],
  ["thief", "thieves"],
  ["groove", "grooves"],
  ["pickaxe", "pickaxes"],
  ["passerby", "passersby"],
  ["canvas", "canvases"]
].forEach(function(rule) {
  return pluralize.addIrregularRule(rule[0], rule[1]);
});
[
  [/s?$/i, "s"],
  [/[^\u0000-\u007F]$/i, "$0"],
  [/([^aeiou]ese)$/i, "$1"],
  [/(ax|test)is$/i, "$1es"],
  [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
  [/(e[mn]u)s?$/i, "$1s"],
  [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
  [
    /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
    "$1i"
  ],
  [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
  [/(seraph|cherub)(?:im)?$/i, "$1im"],
  [/(her|at|gr)o$/i, "$1oes"],
  [
    /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
    "$1a"
  ],
  [
    /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
    "$1a"
  ],
  [/sis$/i, "ses"],
  [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
  [/([^aeiouy]|qu)y$/i, "$1ies"],
  [/([^ch][ieo][ln])ey$/i, "$1ies"],
  [/(x|ch|ss|sh|zz)$/i, "$1es"],
  [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
  [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
  [/(pe)(?:rson|ople)$/i, "$1ople"],
  [/(child)(?:ren)?$/i, "$1ren"],
  [/eaux$/i, "$0"],
  [/m[ae]n$/i, "men"],
  ["thou", "you"]
].forEach(function(rule) {
  return pluralize.addPluralRule(rule[0], rule[1]);
});
[
  [/s$/i, ""],
  [/(ss)$/i, "$1"],
  [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
  [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
  [/ies$/i, "y"],
  [/(dg|ss|ois|lk|ok|wn|mb|th|ch|ec|oal|is|ck|ix|sser|ts|wb)ies$/i, "$1ie"],
  [
    /\b(l|(?:neck|cross|hog|aun)?t|coll|faer|food|gen|goon|group|hipp|junk|vegg|(?:pork)?p|charl|calor|cut)ies$/i,
    "$1ie"
  ],
  [/\b(mon|smil)ies$/i, "$1ey"],
  [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
  [/(seraph|cherub)im$/i, "$1"],
  [
    /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
    "$1"
  ],
  [
    /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
    "$1sis"
  ],
  [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
  [/(test)(?:is|es)$/i, "$1is"],
  [
    /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
    "$1us"
  ],
  [
    /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
    "$1um"
  ],
  [
    /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
    "$1on"
  ],
  [/(alumn|alg|vertebr)ae$/i, "$1a"],
  [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
  [/(matr|append)ices$/i, "$1ix"],
  [/(pe)(rson|ople)$/i, "$1rson"],
  [/(child)ren$/i, "$1"],
  [/(eau)x?$/i, "$1"],
  [/men$/i, "man"]
].forEach(function(rule) {
  return pluralize.addSingularRule(rule[0], rule[1]);
});
[
  // Singular words with no plurals.
  "adulthood",
  "advice",
  "agenda",
  "aid",
  "aircraft",
  "alcohol",
  "ammo",
  "analytics",
  "anime",
  "athletics",
  "audio",
  "bison",
  "blood",
  "bream",
  "buffalo",
  "butter",
  "carp",
  "cash",
  "chassis",
  "chess",
  "clothing",
  "cod",
  "commerce",
  "cooperation",
  "corps",
  "debris",
  "diabetes",
  "digestion",
  "elk",
  "energy",
  "equipment",
  "excretion",
  "expertise",
  "firmware",
  "flounder",
  "fun",
  "gallows",
  "garbage",
  "graffiti",
  "hardware",
  "headquarters",
  "health",
  "herpes",
  "highjinks",
  "homework",
  "housework",
  "information",
  "jeans",
  "justice",
  "kudos",
  "labour",
  "literature",
  "machinery",
  "mackerel",
  "mail",
  "media",
  "mews",
  "moose",
  "music",
  "mud",
  "manga",
  "news",
  "only",
  "personnel",
  "pike",
  "plankton",
  "pliers",
  "police",
  "pollution",
  "premises",
  "rain",
  "research",
  "rice",
  "salmon",
  "scissors",
  "series",
  "sewage",
  "shambles",
  "shrimp",
  "software",
  "staff",
  "swine",
  "tennis",
  "traffic",
  "transportation",
  "trout",
  "tuna",
  "wealth",
  "welfare",
  "whiting",
  "wildebeest",
  "wildlife",
  "you",
  /pok[eé]mon$/i,
  // Regexes.
  /[^aeiou]ese$/i,
  // "chinese", "japanese"
  /deer$/i,
  // "deer", "reindeer"
  /fish$/i,
  // "fish", "blowfish", "angelfish"
  /measles$/i,
  /o[iu]s$/i,
  // "carnivorous"
  /pox$/i,
  // "chickpox", "smallpox"
  /sheep$/i
].forEach(pluralize.addUncountableRule);

// src/components/FilterSelect/utils/functions.ts
var getOptionLabelByValue = (options, value) => {
  const option = options.find((option2) => option2.value === value);
  return option ? option.label : "";
};

// src/components/FilterSelect/components/SelectLabel.tsx
function SelectLabel(props) {
  var _a;
  const {
    options,
    propsSelectedValue,
    label,
    savedVisibleSelectedFiltersCount,
    disableAllInLabel
  } = props;
  return /* @__PURE__ */ React10.createElement(Typography, { gap: "4px", fontSize: 12, color: "#000" }, !propsSelectedValue && typeof propsSelectedValue !== typeof ((_a = options[0]) == null ? void 0 : _a.value) || Array.isArray(propsSelectedValue) && propsSelectedValue.length === 0 ? `Select${label ? ` ${label}` : ""}` : Array.isArray(propsSelectedValue) ? propsSelectedValue.length === 1 ? getOptionLabelByValue(options, propsSelectedValue[0]) : !disableAllInLabel && savedVisibleSelectedFiltersCount === options.length ? /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(
    Typography,
    {
      component: "span",
      fontWeight: 600,
      fontSize: "inherit",
      color: "#000",
      display: "inline"
    },
    "All (",
    options.length,
    ")"
  ), " ", label ? pluralize(label) : "selected") : `${label ? pluralize(label) : "Selected"} (${savedVisibleSelectedFiltersCount})` : getOptionLabelByValue(options, propsSelectedValue) || `Select${label ? ` ${label}` : ""}`);
}
var SelectLabel_default = SelectLabel;

// src/components/FilterSelect/views/MultiSelect/MultiSelect.tsx
function MultiSelect(props) {
  const {
    options,
    value: propsSelectedValue,
    onChange,
    label,
    icon,
    renderValue,
    renderOption,
    discardPreviousSelectionsOnSelect,
    discardPreviousSelectionsOnSelectAll,
    disabled,
    disableApplyBtn,
    disableSearch,
    disableOnlyBtn,
    disableSelectAll,
    disableScrollLock,
    showRemoveFilter,
    disableSort,
    disableAllInLabel,
    showSelectedFirst,
    selectButtonSx,
    menuItemSx,
    extraMenuItem,
    menuWidth,
    listAnchorPosition = {
      vertical: "bottom",
      horizontal: "left"
    },
    onCancel,
    onRemoveFilter
  } = props;
  const [popoverAnchorEl, setPopoverAnchorEl] = React10.useState(
    null
  );
  const [searchText, setSearchText] = React10.useState("");
  const [selectedValue, setSelectedValue] = React10.useState(propsSelectedValue);
  const optionsMatchingSearchText = React10.useMemo(() => {
    const lowerCaseSearchText = searchText.toLowerCase();
    const orderedOptions = showSelectedFirst ? [
      ...options.filter(
        (option) => propsSelectedValue.includes(option.value)
      ),
      ...options.filter(
        (option) => !propsSelectedValue.includes(option.value)
      )
    ] : [...options];
    if (!disableSort)
      orderedOptions.sort((a, b) => {
        if (showSelectedFirst && propsSelectedValue.includes(a.value) !== propsSelectedValue.includes(b.value))
          return 0;
        return get(a, "label", "").localeCompare(get(b, "label", ""));
      });
    return orderedOptions.filter((obj) => {
      var _a, _b, _c, _d, _e, _f;
      return ((_c = (_b = (_a = get(obj, "label", "")) == null ? void 0 : _a.toString()) == null ? void 0 : _b.toLowerCase()) == null ? void 0 : _c.includes(lowerCaseSearchText)) || ((_f = (_e = (_d = get(obj, "value", "")) == null ? void 0 : _d.toString()) == null ? void 0 : _e.toLowerCase()) == null ? void 0 : _f.includes(lowerCaseSearchText));
    });
  }, [options, searchText, selectedValue, showSelectedFirst, disableSort]);
  const localVisibleSelectedIntersectionCount = React10.useMemo(() => {
    return selectedValue.filter(
      (val) => options.some((option) => option.value === val)
    ).length;
  }, [options, selectedValue]);
  const savedVisibleSelectedFiltersCount = React10.useMemo(() => {
    return propsSelectedValue.filter(
      (val) => options.some((option) => option.value === val)
    ).length;
  }, [options, propsSelectedValue]);
  const isSelectAll = React10.useMemo(() => {
    return optionsMatchingSearchText.every(
      (obj) => selectedValue.includes(obj.value)
    );
  }, [optionsMatchingSearchText, selectedValue]);
  const isChanged = React10.useMemo(() => {
    if (disableApplyBtn) {
      return false;
    }
    if (propsSelectedValue.length !== selectedValue.length) {
      return true;
    }
    return selectedValue.some((val) => !propsSelectedValue.includes(val));
  }, [disableApplyBtn, propsSelectedValue, selectedValue]);
  const selectAllLabel = React10.useMemo(() => {
    if (!discardPreviousSelectionsOnSelectAll) {
      if (searchText === "") {
        if (isSelectAll) return "Unselect All";
        else return "Select All";
      } else {
        if (isSelectAll) return "Remove Search Results";
        else return "Add Search Results";
      }
    } else {
      if (searchText === "") {
        if (isSelectAll) return "Unselect All";
        else return "Select All";
      } else {
        if (isSelectAll) return "Unselect Search Results";
        else return "Select Search Results";
      }
    }
  }, [discardPreviousSelectionsOnSelectAll, searchText, isSelectAll]);
  React10.useEffect(() => {
    setSelectedValue(propsSelectedValue);
  }, [propsSelectedValue]);
  const handlePopoverOpen = (event) => {
    setPopoverAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setPopoverAnchorEl(null);
    setSelectedValue(propsSelectedValue);
    setSearchText("");
  };
  const handleSelectAllChange = (event, checked) => {
    event.stopPropagation();
    let newSelectedValues = [];
    if (!discardPreviousSelectionsOnSelectAll) {
      const newSelectedValuesSet = new Set(selectedValue);
      if (checked) {
        optionsMatchingSearchText.forEach(
          (option) => newSelectedValuesSet.add(option.value)
        );
      } else {
        optionsMatchingSearchText.forEach(
          (option) => newSelectedValuesSet.delete(option.value)
        );
      }
      newSelectedValues = [...newSelectedValuesSet];
    } else {
      if (checked) {
        newSelectedValues = optionsMatchingSearchText.map(
          (option) => option.value
        );
      }
    }
    if (!disableApplyBtn) {
      setSelectedValue(newSelectedValues);
    } else {
      onChange(
        newSelectedValues,
        newSelectedValues.map(
          (val) => options.find((option) => option.value === val)
        )
      );
      handlePopoverClose();
    }
  };
  const handleSelect = (data, checked) => {
    let newSelectedValue = !discardPreviousSelectionsOnSelect ? [...selectedValue] : selectedValue.filter((value) => {
      if (value.toString().toLowerCase().includes(searchText.toLowerCase()))
        return true;
      const option = options.find((option2) => option2.value === value);
      if (option && option.label.toLowerCase().includes(searchText.toLowerCase()))
        return true;
      return false;
    });
    if (checked) newSelectedValue = [.../* @__PURE__ */ new Set([...newSelectedValue, data])];
    else newSelectedValue = newSelectedValue.filter((value) => value !== data);
    if (!disableApplyBtn) {
      setSelectedValue(newSelectedValue);
    } else {
      onChange(
        newSelectedValue,
        newSelectedValue.map(
          (val) => options.find((option) => option.value === val)
        )
      );
      handlePopoverClose();
    }
  };
  const handleOnlySelect = (data) => {
    onChange([data], [options.find((option) => option.value === data)]);
    handlePopoverClose();
  };
  const handleApplyClick = () => {
    onChange(
      selectedValue,
      selectedValue.map((val) => options.find((option) => option.value === val))
    );
    handlePopoverClose();
  };
  const handleCancelClick = () => {
    handlePopoverClose();
    if (onCancel) onCancel();
  };
  const handleRemoveFilter = () => {
    onChange([], []);
    if (onRemoveFilter) onRemoveFilter();
  };
  const handleClearSelections = () => {
    setSelectedValue([]);
  };
  return /* @__PURE__ */ React10.createElement(ErrorBoundary_default, { componentName: "MultiSelect" }, /* @__PURE__ */ React10.createElement(ThemeProvider, null, showRemoveFilter ? /* @__PURE__ */ React10.createElement(
    ButtonGroup,
    {
      sx: {
        "& .MuiButtonGroup-grouped": { minWidth: "20px" }
      }
    },
    /* @__PURE__ */ React10.createElement(
      Button,
      {
        disabled,
        variant: "text",
        onClick: handlePopoverOpen,
        startIcon: icon ? typeof icon === "string" ? /* @__PURE__ */ React10.createElement(Icon, { sx: { fontSize: "12px", color: "#000" } }, icon) : icon : null,
        endIcon: /* @__PURE__ */ React10.createElement(
          ExpandMoreIcon,
          {
            sx: {
              width: "16px",
              height: "16px",
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)"
            }
          }
        ),
        sx: __spreadValues({
          padding: "7px 28px 7px 8px",
          color: "#000",
          fontSize: "12px",
          fontWeight: "400",
          justifyContent: "start",
          backgroundColor: popoverAnchorEl ? "#E1ECEF" : "#F3F3F3",
          "&:hover": { backgroundColor: "#E4E4E4" },
          "& .MuiButton-startIcon": { marginLeft: 0 },
          "& .MuiSvgIcon-root": { fontSize: "12px" },
          "& .MuiButton-endIcon": { marginRight: 0 },
          "&.Mui-disabled": { bgcolor: "#F3F3F3" }
        }, selectButtonSx),
        "data-testid": "selectBtn"
      },
      renderValue ? renderValue(selectedValue) : /* @__PURE__ */ React10.createElement(
        SelectLabel_default,
        {
          options,
          propsSelectedValue,
          label,
          savedVisibleSelectedFiltersCount,
          disableAllInLabel
        }
      )
    ),
    /* @__PURE__ */ React10.createElement(
      Button,
      {
        disabled,
        onClick: handleRemoveFilter,
        sx: __spreadValues({
          padding: "4px 8px",
          border: "none",
          borderLeft: "1px solid #E4E4E4",
          color: "#000",
          backgroundColor: "#F3F3F3",
          "&:hover": {
            backgroundColor: "#E4E4E4",
            border: "none",
            borderLeft: "1px solid #E4E4E4"
          },
          "&.Mui-disabled": { bgcolor: "#F3F3F3" }
        }, selectButtonSx)
      },
      /* @__PURE__ */ React10.createElement(ClearIcon, { sx: { width: "12px", height: "12px" } })
    )
  ) : /* @__PURE__ */ React10.createElement(
    Button,
    {
      disabled,
      variant: "text",
      onClick: handlePopoverOpen,
      startIcon: icon ? typeof icon === "string" ? /* @__PURE__ */ React10.createElement(Icon, { sx: { fontSize: "12px", color: "#000" } }, icon) : icon : null,
      endIcon: /* @__PURE__ */ React10.createElement(
        ExpandMoreIcon,
        {
          sx: {
            width: "16px",
            height: "16px",
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)"
          }
        }
      ),
      sx: __spreadValues({
        padding: "7px 28px 7px 8px",
        color: "#000",
        fontSize: "12px",
        fontWeight: "400",
        justifyContent: "start",
        backgroundColor: popoverAnchorEl ? "#E1ECEF" : "#F3F3F3",
        "&:hover": { backgroundColor: "#E4E4E4" },
        "& .MuiButton-startIcon": { marginLeft: 0 },
        "& .MuiSvgIcon-root": { fontSize: "12px" },
        "& .MuiButton-endIcon": { marginRight: 0 },
        "&.Mui-disabled": { bgcolor: "#F3F3F3" }
      }, selectButtonSx),
      "data-testid": "selectBtn"
    },
    renderValue ? renderValue(selectedValue) : /* @__PURE__ */ React10.createElement(
      SelectLabel_default,
      {
        options,
        propsSelectedValue,
        label,
        savedVisibleSelectedFiltersCount,
        disableAllInLabel
      }
    )
  ), /* @__PURE__ */ React10.createElement(
    Popover,
    {
      open: Boolean(popoverAnchorEl),
      anchorEl: popoverAnchorEl,
      onClose: handlePopoverClose,
      anchorOrigin: listAnchorPosition,
      disableScrollLock,
      marginThreshold: 40,
      sx: {
        "& .MuiPopover-paper": {
          border: "1px solid #E6E6E6",
          borderRadius: "4px"
        },
        "& ::-webkit-scrollbar": { width: "4px" },
        "& ::-webkit-scrollbar-track": { background: "#FFF" },
        "& ::-webkit-scrollbar-thumb": {
          background: "#AAA",
          borderRadius: "4px"
        }
      }
    },
    /* @__PURE__ */ React10.createElement(
      Box,
      {
        sx: {
          px: "16px",
          pt: "16px",
          pl: "20px",
          bgcolor: "white",
          zIndex: 5,
          position: "sticky",
          top: 0
        }
      },
      !disableSearch && /* @__PURE__ */ React10.createElement(
        SearchBar_default,
        {
          searchText,
          setSearchText,
          label,
          multiple: true
        }
      ),
      extraMenuItem,
      !disableSelectAll && optionsMatchingSearchText.length > 0 && /* @__PURE__ */ React10.createElement(
        SelectAll_default,
        {
          isSelectAll,
          handleSelectAllChange,
          selectAllLabel: `${selectAllLabel} (${optionsMatchingSearchText.length})`,
          handleClearSelections
        }
      )
    ),
    optionsMatchingSearchText.length > 0 ? /* @__PURE__ */ React10.createElement(
      OptionsList_default,
      {
        options: optionsMatchingSearchText,
        optionItemProps: {
          handleSelect,
          label,
          disableOnlyBtn,
          handleOnlyClick: handleOnlySelect,
          menuItemSx
        },
        renderOption,
        selectedValue,
        isChanged,
        width: menuWidth,
        multiple: true
      }
    ) : /* @__PURE__ */ React10.createElement(Box, { sx: { p: 2, textAlign: "center" } }, /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000" }, "No options found")),
    isChanged && optionsMatchingSearchText.length > 0 && /* @__PURE__ */ React10.createElement(
      ApplyCancel_default,
      {
        isChanged,
        handleApplyClick,
        handleCancelClick,
        changedLabel: `${localVisibleSelectedIntersectionCount} selected`
      }
    )
  )));
}
var MultiSelect_default = MultiSelect;
function SingleSelect(props) {
  const {
    options,
    value: propsSelectedValue,
    onChange,
    label,
    icon,
    renderValue,
    renderOption,
    disabled,
    disableSearch,
    disableSort,
    disableScrollLock,
    addUndefinedOption,
    selectButtonSx,
    menuItemSx,
    extraMenuItem,
    menuWidth,
    listAnchorPosition = {
      vertical: "bottom",
      horizontal: "left"
    }
  } = props;
  const [popoverAnchorEl, setPopoverAnchorEl] = React10.useState(
    null
  );
  const [searchText, setSearchText] = React10.useState("");
  const [selectedValue, setSelectedValue] = React10.useState(propsSelectedValue);
  const optionsMatchingSearchText = React10.useMemo(() => {
    const lowerCaseSearchText = searchText.toLowerCase();
    if (!disableSort)
      options.sort(
        (a, b) => get(a, "label", "").localeCompare(get(b, "label", ""))
      );
    return options.filter((obj) => {
      var _a, _b, _c, _d, _e, _f;
      return ((_c = (_b = (_a = get(obj, "label", "")) == null ? void 0 : _a.toString()) == null ? void 0 : _b.toLowerCase()) == null ? void 0 : _c.includes(lowerCaseSearchText)) || ((_f = (_e = (_d = get(obj, "value", "")) == null ? void 0 : _d.toString()) == null ? void 0 : _e.toLowerCase()) == null ? void 0 : _f.includes(lowerCaseSearchText));
    });
  }, [options, searchText]);
  React10.useEffect(() => {
    setSelectedValue(propsSelectedValue);
  }, [propsSelectedValue]);
  const handlePopoverOpen = (event) => {
    setPopoverAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setPopoverAnchorEl(null);
    setSelectedValue(propsSelectedValue);
    setSearchText("");
  };
  const handleSelect = (data) => {
    onChange(data, data !== void 0 && options.find((o) => o.value === data));
    handlePopoverClose();
  };
  return /* @__PURE__ */ React10.createElement(ErrorBoundary_default, { componentName: "SingleSelect" }, /* @__PURE__ */ React10.createElement(ThemeProvider, null, /* @__PURE__ */ React10.createElement(
    Button,
    {
      disabled,
      variant: "text",
      onClick: handlePopoverOpen,
      startIcon: icon ? typeof icon === "string" ? /* @__PURE__ */ React10.createElement(Icon, { sx: { fontSize: "12px", color: "#000" } }, icon) : icon : null,
      endIcon: /* @__PURE__ */ React10.createElement(
        ExpandMoreIcon,
        {
          sx: {
            width: "16px",
            height: "16px",
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)"
          }
        }
      ),
      sx: __spreadValues({
        padding: "7px 28px 7px 8px",
        color: "#000",
        fontSize: "12px",
        backgroundColor: popoverAnchorEl ? "#E1ECEF" : "#F3F3F3",
        justifyContent: "start",
        "&:hover": { backgroundColor: "#E4E4E4" },
        "& .MuiButton-startIcon": { marginLeft: 0 },
        "& .MuiSvgIcon-root": { fontSize: "12px" },
        "& .MuiButton-endIcon": { marginRight: 0 },
        "&.Mui-disabled": { bgcolor: "#F3F3F3" }
      }, selectButtonSx),
      "data-testid": "selectBtn"
    },
    renderValue ? renderValue(selectedValue) : /* @__PURE__ */ React10.createElement(
      SelectLabel_default,
      {
        options,
        propsSelectedValue,
        label
      }
    )
  ), /* @__PURE__ */ React10.createElement(
    Popover,
    {
      open: Boolean(popoverAnchorEl),
      anchorEl: popoverAnchorEl,
      onClose: handlePopoverClose,
      anchorOrigin: listAnchorPosition,
      disableScrollLock,
      marginThreshold: 40,
      sx: {
        "& .MuiPopover-paper": {
          border: "1px solid #E6E6E6",
          borderRadius: "4px"
        },
        "& ::-webkit-scrollbar": { width: "4px" },
        "& ::-webkit-scrollbar-track": { background: "#FFF" },
        "& ::-webkit-scrollbar-thumb": {
          background: "#AAA",
          borderRadius: "4px"
        }
      }
    },
    !disableSearch && /* @__PURE__ */ React10.createElement(
      Box,
      {
        sx: {
          px: "16px",
          pt: "16px",
          pl: "16px",
          bgcolor: "white",
          zIndex: 5,
          position: "sticky",
          top: 0
        }
      },
      /* @__PURE__ */ React10.createElement(
        SearchBar_default,
        {
          searchText,
          setSearchText,
          label
        }
      )
    ),
    extraMenuItem,
    optionsMatchingSearchText.length > 0 ? /* @__PURE__ */ React10.createElement(
      OptionsList_default,
      {
        options: optionsMatchingSearchText,
        optionItemProps: {
          handleSelect,
          label,
          menuItemSx
        },
        selectedValue,
        renderOption,
        addUndefinedOption,
        width: menuWidth
      }
    ) : /* @__PURE__ */ React10.createElement(Box, { sx: { p: 2, textAlign: "center" } }, /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000" }, "No options found"))
  )));
}
var SingleSelect_default = SingleSelect;
function OptionsPane(props) {
  const {
    options,
    isSelected,
    handleSelect,
    label,
    renderOption,
    disableSearch,
    disableSelectAll,
    disableSort,
    handleSelectAllChange,
    width,
    height,
    menuItemSx
  } = props;
  const [searchText, setSearchText] = React10.useState("");
  const optionsMatchingSearchText = React10.useMemo(() => {
    const lowerCaseSearchText = searchText.toLowerCase();
    if (!disableSort)
      options.sort(
        (a, b) => get(a, "label", "").localeCompare(get(b, "label", ""))
      );
    return options.filter((obj) => {
      return get(obj, "label", "").toLowerCase().includes(lowerCaseSearchText) || get(obj, "value", "").toString().toLowerCase().includes(lowerCaseSearchText);
    });
  }, [options, searchText]);
  const selectAllLabel = React10.useMemo(() => {
    if (searchText === "") {
      if (isSelected) return "Unselect All";
      else return "Select All";
    } else {
      if (isSelected) return "Remove Search Results";
      else return "Add Search Results";
    }
  }, [searchText, isSelected]);
  const handleSelectAll = (event, checked) => {
    handleSelectAllChange(
      event,
      optionsMatchingSearchText.map((option) => option.value),
      checked
    );
  };
  return /* @__PURE__ */ React10.createElement(
    Box,
    {
      sx: {
        "& ::-webkit-scrollbar": { width: "4px" },
        "& ::-webkit-scrollbar-track": { background: "#FFF" },
        "& ::-webkit-scrollbar-thumb": {
          background: "#AAA",
          borderRadius: "4px"
        }
      }
    },
    !disableSearch && /* @__PURE__ */ React10.createElement(
      SearchBar_default,
      {
        searchText,
        setSearchText,
        label,
        multiple: true,
        sx: {
          pl: "2px",
          width
        }
      }
    ),
    /* @__PURE__ */ React10.createElement(
      Box,
      {
        sx: {
          pr: "16px",
          pl: "20px",
          pt: "8px",
          bgcolor: "white",
          zIndex: 5,
          position: "sticky",
          top: 0
        }
      },
      !disableSelectAll && /* @__PURE__ */ React10.createElement(
        SelectAll_default,
        {
          isSelectAll: isSelected,
          handleSelectAllChange: handleSelectAll,
          selectAllLabel: `${selectAllLabel} (${optionsMatchingSearchText.length})`
        }
      )
    ),
    optionsMatchingSearchText.length > 0 ? /* @__PURE__ */ React10.createElement(
      OptionsList_default,
      {
        options: optionsMatchingSearchText,
        optionItemProps: {
          handleSelect,
          label,
          disableOnlyBtn: true,
          menuItemSx: __spreadValues({
            borderTop: "1px solid #ddd"
          }, menuItemSx)
        },
        multiple: true,
        renderOption,
        selectedValue: isSelected ? options.map((option) => option.value) : [],
        height: height || 300,
        width
      }
    ) : /* @__PURE__ */ React10.createElement(Box, { sx: { p: 2, textAlign: "center" } }, /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000" }, "No options found"))
  );
}
var OptionsPane_default = OptionsPane;

// src/components/FilterSelect/views/SplitSelect/SplitSelect.tsx
function SplitSelect(props) {
  const {
    options,
    value: propsSelectedValue,
    onChange,
    label,
    leftTitle,
    rightTitle,
    renderOption,
    showApplyBtnOnChange,
    enableApplyAlways,
    disableSearch,
    disableSelectAll,
    disableSort,
    includeSelectedValues: propsIncludeSelectedValues,
    onCancel,
    optionListHeight = 300,
    menuItemSx,
    callApplyOnChange = false
  } = props;
  const [selectedValue, setSelectedValue] = React10.useState(propsSelectedValue);
  const [includeSelectedValues, setIncludeSelectedValues] = React10.useState(propsIncludeSelectedValues);
  const [animation, setAnimation] = React10.useState({
    element: null,
    loading: false
  });
  const gridParentRef = React10.useRef(null);
  const leftPaneRef = React10.useRef(null);
  const rightPaneRef = React10.useRef(null);
  const animatedOptionContainerRef = React10.useRef(null);
  const segregatedOptions = React10.useMemo(() => {
    const res = {
      selected: [],
      unselected: []
    };
    options.forEach((option) => {
      if (selectedValue.includes(option.value)) res.selected.push(option);
      else res.unselected.push(option);
    });
    return res;
  }, [options, selectedValue]);
  const isChanged = React10.useMemo(() => {
    if (propsSelectedValue.length !== selectedValue.length) {
      return true;
    }
    return selectedValue.some((val) => !propsSelectedValue.includes(val));
  }, [propsSelectedValue, selectedValue]);
  React10.useEffect(() => {
    setSelectedValue(propsSelectedValue);
  }, [propsSelectedValue]);
  const handleSelect = (value, checked, event) => {
    var _a, _b, _c;
    const elementY = event == null ? void 0 : event.currentTarget.getBoundingClientRect().y;
    const leftPane = (_a = leftPaneRef == null ? void 0 : leftPaneRef.current) == null ? void 0 : _a.getBoundingClientRect();
    const rightPane = (_b = rightPaneRef == null ? void 0 : rightPaneRef.current) == null ? void 0 : _b.getBoundingClientRect();
    const parent = (_c = gridParentRef == null ? void 0 : gridParentRef.current) == null ? void 0 : _c.getBoundingClientRect();
    const htmlString = event.currentTarget.innerHTML;
    const clonedElement = /* @__PURE__ */ React10.createElement(
      "div",
      {
        style: { width: leftPane.width - 16 },
        dangerouslySetInnerHTML: { __html: htmlString }
      }
    );
    setAnimation({ element: clonedElement, loading: true });
    animatedOptionContainerRef.current.style.visibility = "visible";
    gsap.fromTo(
      animatedOptionContainerRef.current,
      {
        top: elementY - leftPane.y,
        left: checked ? leftPane.x - parent.x + 16 : rightPane.x - parent.x + 16
      },
      {
        left: checked ? rightPane.x - parent.x + 16 : leftPane.x - parent.x + 16,
        duration: 0.5,
        onComplete: () => {
          animatedOptionContainerRef.current.style.visibility = "hidden";
          const newValue = checked ? [...selectedValue, value] : selectedValue.filter((val) => val !== value);
          setSelectedValue(newValue);
          setAnimation((prev) => __spreadProps(__spreadValues({}, prev), { loading: false }));
        }
      }
    );
  };
  const handleSelectAll = (event, values, checked) => {
    event.stopPropagation();
    setAnimation((prev) => __spreadProps(__spreadValues({}, prev), { loading: true }));
    setTimeout(() => {
      const newValue = checked ? [...selectedValue, ...values] : selectedValue.filter((val) => !values.includes(val));
      setSelectedValue([...new Set(newValue)]);
      setAnimation((prev) => __spreadProps(__spreadValues({}, prev), { loading: false }));
    }, 500);
  };
  const handleApplyClick = () => {
    if ("includeSelectedValues" in props)
      onChange(
        selectedValue,
        selectedValue.map(
          (value) => options.find((option) => option.value === value)
        ),
        includeSelectedValues
      );
    else
      onChange(
        selectedValue,
        selectedValue.map(
          (value) => options.find((option) => option.value === value)
        )
      );
  };
  const handleCancelClick = () => {
    setSelectedValue(propsSelectedValue);
    setIncludeSelectedValues(propsIncludeSelectedValues);
    if (onCancel) onCancel();
  };
  useEffect(() => {
    if (callApplyOnChange) handleApplyClick();
  }, [selectedValue]);
  return /* @__PURE__ */ React10.createElement(ErrorBoundary_default, { componentName: "FilterSelect" }, /* @__PURE__ */ React10.createElement(ThemeProvider, null, /* @__PURE__ */ React10.createElement(
    Box,
    {
      sx: {
        display: "flex",
        justifyContent: "flex-end",
        px: "10px"
      }
    },
    "includeSelectedValues" in props && /* @__PURE__ */ React10.createElement(RadioGroup, null, /* @__PURE__ */ React10.createElement(
      Stack,
      {
        direction: "row",
        alignItems: "center",
        justifyContent: "center"
      },
      /* @__PURE__ */ React10.createElement(
        Stack,
        {
          direction: "row",
          alignItems: "center",
          justifyContent: "flex-end"
        },
        /* @__PURE__ */ React10.createElement(
          Radio,
          {
            checked: includeSelectedValues,
            onChange: () => {
              setIncludeSelectedValues(true);
            },
            size: "small",
            "data-testid": "includeRadio"
          }
        ),
        /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000" }, "Include")
      ),
      /* @__PURE__ */ React10.createElement(
        Stack,
        {
          direction: "row",
          alignItems: "center",
          justifyContent: "flex-end"
        },
        /* @__PURE__ */ React10.createElement(
          Radio,
          {
            checked: !includeSelectedValues,
            onChange: () => {
              setIncludeSelectedValues(false);
            },
            size: "small",
            "data-testid": "excludeRadio"
          }
        ),
        /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000" }, "Exclude")
      )
    ))
  ), /* @__PURE__ */ React10.createElement(
    Grid,
    {
      container: true,
      spacing: 2,
      mt: 0,
      sx: { position: "relative" },
      ref: gridParentRef
    },
    /* @__PURE__ */ React10.createElement(
      Box,
      {
        ref: animatedOptionContainerRef,
        sx: {
          position: "absolute",
          zIndex: 11,
          visibility: "hidden",
          backgroundColor: "#fff"
        }
      },
      animation.element
    ),
    /* @__PURE__ */ React10.createElement(
      Box,
      {
        sx: {
          backgroundColor: "#8888",
          position: "absolute",
          left: 10,
          right: 4,
          top: 0,
          bottom: 0,
          zIndex: 10,
          display: animation.loading ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center"
        }
      },
      /* @__PURE__ */ React10.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 }, /* @__PURE__ */ React10.createElement(Typography, { color: "#fff" }, "Processing"), /* @__PURE__ */ React10.createElement(CircularProgress, { size: 16, sx: { color: "#fff" } }))
    ),
    /* @__PURE__ */ React10.createElement(Grid, { item: true, xs: 12, md: 6, ref: leftPaneRef, "data-testid": "leftPanel" }, /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000", fontWeight: 600 }, leftTitle ? leftTitle : `Select ${label && pluralize(label)} (${segregatedOptions.unselected.length})`), /* @__PURE__ */ React10.createElement(
      OptionsPane_default,
      {
        options: segregatedOptions.unselected,
        isSelected: false,
        handleSelect,
        renderOption,
        disableSearch,
        disableSelectAll,
        disableSort,
        handleSelectAllChange: handleSelectAll,
        width: "calc(100% - 16px)",
        height: optionListHeight,
        menuItemSx
      }
    )),
    /* @__PURE__ */ React10.createElement(Grid, { item: true, xs: 12, md: 6, ref: rightPaneRef, "data-testid": "rightPanel" }, /* @__PURE__ */ React10.createElement(Typography, { fontSize: 12, color: "#000", fontWeight: 600 }, rightTitle ? rightTitle : `Selected ${label && pluralize(label)} (${segregatedOptions.selected.length})`), /* @__PURE__ */ React10.createElement(
      OptionsPane_default,
      {
        options: segregatedOptions.selected,
        isSelected: true,
        handleSelect,
        renderOption,
        disableSearch,
        disableSelectAll,
        disableSort,
        handleSelectAllChange: handleSelectAll,
        width: "calc(100% - 16px)",
        height: optionListHeight,
        menuItemSx
      }
    ))
  ), (!showApplyBtnOnChange || isChanged || includeSelectedValues !== propsIncludeSelectedValues) && !callApplyOnChange && /* @__PURE__ */ React10.createElement(
    ApplyCancel_default,
    {
      isChanged: isChanged || includeSelectedValues !== propsIncludeSelectedValues,
      handleApplyClick,
      handleCancelClick,
      changedLabel: `${selectedValue.length} selected`,
      enableApplyAlways
    }
  )));
}
var SplitSelect_default = SplitSelect;

export { ApplyCancel_default, MultiSelect_default, SingleSelect_default, SplitSelect_default, pluralize };
//# sourceMappingURL=chunk-6UBOFWLJ.js.map
//# sourceMappingURL=chunk-6UBOFWLJ.js.map